import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { useSEO } from "@/hooks/useSEO";

const SUGGESTIONS = [
  { to: "/", label: "Female Partner Calculator" },
  { to: "/male-partner-calculator", label: "Male Partner Calculator" },
  { to: "/dating-standards-calculator", label: "Dating Standards Test" },
  { to: "/stats", label: "US Dating Statistics" },
];

const NotFound = () => {
  const location = useLocation();

  useSEO({
    title: "Page Not Found | Female Partner Calculator",
    description: "This page does not exist. Try one of our calculators or the US dating statistics hub.",
    noindex: true,
  });

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <main className="container mx-auto px-4 py-16">
        <div className="max-w-xl mx-auto text-center space-y-6">
          <h1 className="text-4xl font-bold">Page not found</h1>
          <p className="text-lg text-muted-foreground">
            The page you were looking for doesn&apos;t exist or has moved. Try one of these instead:
          </p>
          <ul className="flex flex-col gap-3">
            {SUGGESTIONS.map((s) => (
              <li key={s.to}>
                <Link to={s.to} className="text-primary hover:underline font-medium">
                  {s.label} →
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
